import proj4 from "proj4";
import {register} from "ol/proj/proj4";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import MyCluster from "./MyCluster"
import Point from "ol/geom/Point";
import WMTSCapabilities from "ol/format/WMTSCapabilities";

import {styleBigFunc, styleFunc} from "./styles";
import {createBaseLayers} from "./baseLayers";
import {createWFSLayers} from "./wfsLayer";

import store from "../store/Store";
import {SET_CONFIG, SET_SEARCHPARAMS} from "../store/mutation-types";
import {GET_SEARCH_PARAMS, GET_VISIBLE_LAYERS} from "../store/getters-types";

import axios from "axios";

proj4.defs(
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

register(proj4);


const WFS_LAYER_LS_BASE_PATH = "https://portal.prvlimburg.nl/geodata/EKL/wfs";
const WFS_LAYER_LS_FEATURETYPE = "EKL:RAAP_LANDSCH_STRUCTUUR_V";


/**
 * Modul Layers
 * 
 * Hier werden alle notwendigen Layer initialisiert und asl Promise objekt
 * zurueckgegeben. Promise weil wir erst mit fetch das capabilities Objekt von
 * geodata.nationaalgeoregister.nl holen muessen
 */


const PUBLIC_MONUMENT_PATH = "/monuments"
const PRIVATE_MONUMENT_PATH = "/monumentsPrivat"
export const RESOLUTION_CLUSTER_BREAKPOINT = 2.5
const PROJECTION = "EPSG:28992"

const authenticateUser = (user, password) => {
    var token = user + ":" + password;

    var auth = 'Basic ' + Buffer.from(token).toString('base64');

    return auth;
}


var params = "test=EE"
var paramsBig = "test=EE"
let layerSourcePromiseResolve = null;
export const layerSourcePromise = new Promise((resolve, reject) => {
    layerSourcePromiseResolve = resolve
});
const serialiseObject = function (obj) {
    var pairs = [];
    for (var prop in obj) {
        if (!obj.hasOwnProperty(prop)) {
            continue;
        }
        if (Object.prototype.toString.call(obj[prop]) == '[object Object]') {
            pairs.push(serialiseObject(obj[prop]));
            continue;
        }
        pairs.push(prop + '=' + obj[prop]);
    }
    return pairs.join('&');
}

const createWFSLayerLS = function (config) {
    const format = new GeoJSON({
        defaultDataProjection: PROJECTION,
        dataProjection: PROJECTION
    })

    const path = WFS_LAYER_LS_BASE_PATH + "?service=wfs&outputFormat=application/json&version=2.0.0&request=GetFeature&typeNames=" + WFS_LAYER_LS_FEATURETYPE
    const typedID = "ls"
    const getSoortID = (soortString) => {
        const availableSoortNames = config.soortLS.map(soort => soort.name)

        const matchedSoort = config.soortLS.find(soort => soort.name === soortString)
        if (matchedSoort) {
            return matchedSoort.id
        } else {
            return null
        }
    }

    function loader(extent, resolution) {

        axios("/proxy/lslayer", {
            params: {
                service: "wfs",
                version: "2.0.0",
                request: "GetFeature",
                typeNames: "EKL:RAAP_LANDSCH_STRUCTUUR_V",
                layer: "RAAP_LANDSCH_STRUCTUUR_V",
                ns: "EKL",
                outputFormat: "application/json"
            },
            headers: {
                hostpath: WFS_LAYER_LS_BASE_PATH,
                Authorization: authenticateUser("geodok", "jG84TicRlQn6")
            },
            withCredentials: true,
        }).then(res => {
            let features = format.readFeatures(res.data);

            const searchParams = store.getters[GET_SEARCH_PARAMS]();

            if (searchParams["gem_code"].value) {
                features = features.filter( f => f.get("GEM_CODE") === searchParams["gem_code"].value);
            }

            if (searchParams["type"].value === "LS" && searchParams["soort"].value) {
                features = features.filter( f => f.get("LANDSCHAP1") === searchParams["soort"].label);
            }

            features.forEach(f => {
                f.setId("LS_ext_" + f.getId())
                f.set("ident", f.get("IDENT"));
                f.set("soort", f.get("LANDSCHAP1"));
                f.set("name", f.get("NAAM"));
                f.set("typedID", typedID);
                f.set("soortID", getSoortID(f.get("LANDSCHAP1")));
            })

            vsource.addFeatures(features);
        })
    }

    const vsource = new VectorSource({
        projection: PROJECTION,
        loader: loader,
        format: format
    })

    const vlayer = new VectorLayer({
        displayInLayerSwitcher: false,
        source: vsource,
        style: styleBigFunc(config),
        name: "layer_ls"
    })
    const isThisTypeVisibleByFilter = () => {
        const searchParams = store.getters[GET_SEARCH_PARAMS]();
        return searchParams["type"].value === "" || searchParams["type"].value === "LS";
    }
    const isTypeVisible = () => {
        const visibleLayerTypes = store.getters[GET_VISIBLE_LAYERS]();
        return visibleLayerTypes.includes("LS")
    }
    store.watch(store.getters[GET_SEARCH_PARAMS], searchParams => {
        vlayer.setVisible(isTypeVisible() && isThisTypeVisibleByFilter());
        if (vlayer.getVisible()) {
            vsource.refresh();
        }
    })
    store.watch(store.getters[GET_VISIBLE_LAYERS], visibleLayerTypes => {

        vlayer.setVisible(isTypeVisible() && isThisTypeVisibleByFilter())
    })

    vlayer.setVisible(isTypeVisible() && isThisTypeVisibleByFilter())

    return vlayer;
}

var createLayersInternal = function (path, config) {
    var layers = {}

    // Vector layer
    layers.editvector = new VectorLayer({
        displayInLayerSwitcher: false,
        source: new VectorSource(),
        style: styleFunc(config),
        name: "editlayer"
    })

    layers.monumentvector = new VectorLayer({
        displayInLayerSwitcher: false,
        source: new VectorSource(),
        style: styleFunc(config),
        name: "monumentvector"
    })

    function onlyBigloader(extent, resolution, projection) {
        axios(path + "?" + paramsBig).then(res => {
            monumentBigSource.addFeatures(monumentBigSource.getFormat().readFeatures(res.data));

        })
    }

    function loader(extent, resolution, projection) {
        axios(path + "?" + params).then(res => {
            monumentSource.addFeatures(monumentSource.getFormat().readFeatures(res.data));
            if (layerSourcePromiseResolve) {
                layerSourcePromiseResolve(monumentSource)
            }

            layerSourcePromiseResolve = null;
        })
    }
    var monumentBigSource = new VectorSource({
        projection: PROJECTION,

        loader: onlyBigloader,
        format: new GeoJSON({
            defaultDataProjection: PROJECTION,
            dataProjection: PROJECTION
        })
    })

    var monumentSource = new VectorSource({
        projection: PROJECTION,

        loader: loader,
        format: new GeoJSON({
            defaultDataProjection: PROJECTION,
            dataProjection: PROJECTION
        })
    })


    var clusterSource = new MyCluster({
        distance: 20,
        source: monumentSource,
        geometryFunction: function (feature) {

            if (feature.getGeometry()) {
                return new Point(feature.getGeometry().getFirstCoordinate());
            } else {
                console.log("error " + feature.get("name"))
                return null;
            }

        }
    });



    layers.vectorLayer = new VectorLayer({
        displayInLayerSwitcher: false,
        title: "monumens",
        baseLayer: false,
        visible: true,
        projection: PROJECTION,
        style: styleFunc(config),
        source: clusterSource,
        minResolution: RESOLUTION_CLUSTER_BREAKPOINT,
    });

    layers.vectorLayerAll = new VectorLayer({
        displayInLayerSwitcher: false,
        title: "monumensAll",
        baseLayer: false,
        visible: true,
        projection: PROJECTION,
        maxResolution: RESOLUTION_CLUSTER_BREAKPOINT,
        source: monumentSource,
        style: styleBigFunc(config),
    });

    layers.vectorLayerBig = new VectorLayer({
        displayInLayerSwitcher: false,
        title: "monumensBig",
        baseLayer: false,
        visible: true,
        projection: PROJECTION,
        source: monumentBigSource,
        style: styleBigFunc(config),
    });

    let visibleLayers = store.getters[GET_VISIBLE_LAYERS]();
    let searchParams = Object.keys(store.state.searchParams).reduce((agg, key) => {
        agg[key] = store.state.searchParams[key].value
        return agg;
    }, {})

    params = serialiseObject(Object.assign({}, searchParams, { fetchTypes: visibleLayers, onlySmall: true }))
    paramsBig = serialiseObject(Object.assign({}, searchParams, { fetchTypes: visibleLayers, onlyBig: true }))

    store.subscribe((mutation, state) => {
        let visibleLayers, searchParams, merged
        switch (mutation.type) {
            case SET_SEARCHPARAMS:
                visibleLayers = store.getters[GET_VISIBLE_LAYERS]();
                searchParams = Object.keys(state.searchParams).reduce((agg, key) => {
                    agg[key] = state.searchParams[key].value
                    return agg;
                }, {})

                params = serialiseObject(Object.assign({}, searchParams, { fetchTypes: visibleLayers, onlySmall: true }))
                paramsBig = serialiseObject(Object.assign({}, searchParams, { fetchTypes: visibleLayers, onlyBig: true }))
                monumentSource.refresh();
                monumentBigSource.refresh()
                break;
            case SET_CONFIG:
                visibleLayers = store.getters[GET_VISIBLE_LAYERS]();
                searchParams = Object.keys(state.searchParams).reduce((agg, key) => {
                    agg[key] = state.searchParams[key].value
                    return agg;
                }, {})
                merged = Object.assign(searchParams, { fetchTypes: visibleLayers })
                params = serialiseObject(merged)
                monumentSource.refresh();
                monumentBigSource.refresh()

                break;


        }

    })



    return layers
}


export const createLayers = function (config) {
    if (store.state.isPublicPage) {

        return doFetch(PUBLIC_MONUMENT_PATH, config)
    } else {
        return doFetch(PRIVATE_MONUMENT_PATH, config)
    }


}



var doFetch = function (path, config) {

    var promise = new Promise(function (resolve, reject) {
        fetch(
            'https://geodata.nationaalgeoregister.nl/tiles/service/wmts?REQUEST=GetCapabilities')
            .then(function (response) {
                return response.text();
            }.bind(this)).then(
                function (text) {
                    var parser = new WMTSCapabilities();
                    var result = parser.read(text);

                    var baseLayers = createBaseLayers(result)

                    var wfsLayers = createWFSLayers()

                    var vectorLayers = createLayersInternal(path, config)

                    const addonClientLayers = [createWFSLayerLS(config)]

                    resolve({
                        background: baseLayers,
                        wfs: wfsLayers,
                        vector: vectorLayers,
                        addonClientLayers: addonClientLayers
                    })
                }.bind(this))

    });

    return promise;
}


export function onLayerStateChange(activeLayerTypes) {
    /*
    layerControlParams.fetchTypes = layerState.getStateAsParam()

    layerState.addListener(function (name, isActive) {

        var layerControlParams = layerState.getStateAsParam()
        monumentSource.set("params", layerControlParams)
    })


    monumentSource.set("params", layerControlParams)
    params = serialiseObject(layerControlParams)
    */
}
export function onSearch(queryparams) {
    /*
    var monumentParamsObject = {
        fetchTypes: layerState.getStateAsParam()
    }
    queryparams = Object.assign(monumentParamsObject, queryparams);

    //modul global variable
    params = serialiseObject(queryparams)

    //monumentSource.set("params", params)
    console.log(JSON.stringify(queryparams))
    monumentSource.clear();
    */

}

